/**
 * @used-by: contract-svc — `DocumentSignatureService.returnUrls()` freezes these three paths into the
 * provider invite (`{ESIGN_RETURN_BASE_URL}/document-signature/{requestId}/{done|declined|closed}`).
 * An invite created with them can stay open for its whole validity window, so never rename them.
 *
 * Matched on `pathname` only. The request id and the query string are never read: the page is static.
 */
export const DOCUMENT_SIGNATURE_RETURN_OUTCOMES = ['done', 'declined', 'closed'] as const;
export type DocumentSignatureReturnOutcome = (typeof DOCUMENT_SIGNATURE_RETURN_OUTCOMES)[number];

const DOCUMENT_SIGNATURE_RETURN_PATH_RE = /^\/document-signature\/[^/]+\/([a-z]+)\/?$/;

export function parseDocumentSignatureReturnPath(
  pathname: string,
): DocumentSignatureReturnOutcome | null {
  const outcome = DOCUMENT_SIGNATURE_RETURN_PATH_RE.exec(pathname)?.[1];
  return (DOCUMENT_SIGNATURE_RETURN_OUTCOMES as readonly (string | undefined)[]).includes(outcome)
    ? (outcome as DocumentSignatureReturnOutcome)
    : null;
}
